import { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import 'styles/BlockComponent.css'
import 'styles/TunnelComponent.css'
import 'styles/WindowComponent.css'
import 'styles/RowComponent.css'
import 'styles/PlantComponent.css'
import TunnelComponent from 'components/common/TunnelComponent'
// import PlantComponent from 'components/common/PlantComponent'

const PLANT_STATES = {
  HEALTHY: 'healthy',
  DISEASE: 'disease',
  NUTRIENT_DEFICIENCY: 'nutrient-deficiency'
}

const VIEWS = {
  overview: 'overview',
  tunnel: 'tunnel',
  row: 'row'
}

const BlockMapComponent = ({
  accessTunnel = 1,
  accessWindow = 1,
  blockConfig = [],
  farmingBlockId,
  isHydroponicBlock,
  toggleIsTunnelRowModalOpen,
  tunnelRefreshRef
}) => {
  const [state, setState] = useState({
    selectedTunnel: null,
    selectedRow: null,
    currentView: VIEWS.overview,
    draggedItem: null,
    numberOfWindows: 0,
    numberOfRows: 0,
    plants: [],
    plantsPerRow: 0,
    selectedFarmingBlockId: ''
    // scale: 1,
  })

  // const {
  //   selectedTunnel,
  //   selectedRow,
  //   currentView,
  //   numberOfWindows
  //   // plants, numberOfRows, plantsPerRow
  // } = state

  // const [scale, setScale] = useState(1)
  // const [rowStates, setRowStates] = useState({})

  // const handleRowClick = (rowIndex) => {
  //   setState((s) => ({
  //     ...s,
  //     selectedRow: rowIndex,
  //     currentView: VIEWS.row
  //   }))
  // }

  // const handleZoomIn = () => {
  //   setScale(prev => Math.min(prev + 0.1, 2.0))
  // }

  // const handleZoomOut = () => {
  //   setScale(prev => Math.max(prev - 0.1, 0.2))
  // }

  // const handleDragStart = (e, status) => {
  //   e.dataTransfer.setData('status', status)
  // }

  // const handleDragOver = (e) => {
  //   e.preventDefault()
  // }

  // const handleDrop = (e, plantIndex) => {
  //   e.preventDefault()
  //   const newStatus = e.dataTransfer.getData('status')
  //   const _plants = plants.map((plant, index) =>
  //     index === plantIndex
  //       ? { ...plant, status: newStatus }
  //       : plant
  //   )
  //   setState((s) => ({
  //     ...s,
  //     plants: _plants
  //   }))
  // }

  // const handleRowStatus = (rowIndex, status) => {
  //   if (status === 'reset') {
  //     setRowStates({}) // Limpiar estados
  //     return
  //   }

  //   if (rowIndex !== null && rowIndex !== undefined) {
  //     setRowStates(prev => ({
  //       ...prev,
  //       [rowIndex]: status
  //     }))
  //   }
  // }

  const handleTunnelClick = (
    tunnelIndex,
    numberOfWindows,
    numberOfRows,
    plantsPerWindow,
    isAccessTunnel
  ) => {
    if (isAccessTunnel) return

    const _plantsPerRow = Array.from(
      { length: plantsPerWindow * numberOfWindows || 0 },
      (_, i) => ({
        id: `plant-${i}`,
        number: i + 1,
        status: PLANT_STATES.HEALTHY
      })
    )

    setState(s => ({
      ...s,
      selectedTunnel: tunnelIndex,
      selectedRow: null,
      currentView: VIEWS.tunnel,
      numberOfWindows,
      numberOfRows,
      plants: _plantsPerRow,
      selectedFarmingBlockId: farmingBlockId
    }))
  }

  const renderBreadcrumbs = () => {
    return (
      <div className='breadcrumbs'>
        <span
          className={`crumb ${state.currentView === 'overview' ? 'active' : ''}`}
          onClick={() => {
            setState((s) => ({
              ...s,
              currentView: VIEWS.overview,
              selectedTunnel: null,
              selectedRow: null
            }))
          }}
        >
          Block Map
        </span>
        {state.selectedTunnel !== null && (
          <>
            <span className='separator'>/</span>
            <span
              className={`crumb ${state.currentView === 'tunnel' ? 'active' : ''}`}
              onClick={() =>
                setState(
                  (s) => ({
                    ...s,
                    currentView: VIEWS.tunnel,
                    selectedRow: null
                  }))}
            >
              Tunnel {state.selectedTunnel + 1}
            </span>
          </>
        )}
        {state.selectedRow !== null && (
          <>
            <span className='separator'>/</span>
            <span
              className={`crumb ${state.currentView === 'row' ? 'active' : ''}`}
              onClick={() => setState(
                (s) => ({
                  ...s,
                  currentView: VIEWS.row
                }))}
            >
              Row {state.selectedRow + 1}
            </span>
          </>
        )}
      </div>
    )
  }

  const dragRef = useRef(null)
  const isDragging = useRef(false)
  const startX = useRef(0)
  const scrollLeft = useRef(0)

  // event listeners for mouse drag, scroll
  // to enable horizontal scrolling on the block content area
  // this is a workaround for the overflow-x-auto
  useEffect(() => {
    const slider = dragRef.current
    if (!slider) return

    const handleMouseDown = e => {
      isDragging.current = true
      startX.current = e.pageX
      scrollLeft.current = slider.scrollLeft
      slider.classList.add('dragging')
    }

    const handleMouseMove = e => {
      if (!isDragging.current) return
      e.preventDefault()
      const x = e.pageX
      const walk = (x - startX.current) * 1.5
      slider.scrollLeft = scrollLeft.current - walk
    }

    const stopDragging = () => {
      isDragging.current = false
      slider.classList.remove('dragging')
    }

    slider.addEventListener('mousedown', handleMouseDown)
    window.addEventListener('mousemove', handleMouseMove)
    window.addEventListener('mouseup', stopDragging)

    return () => {
      slider.removeEventListener('mousedown', handleMouseDown)
      window.removeEventListener('mousemove', handleMouseMove)
      window.removeEventListener('mouseup', stopDragging)
    }
  }, [])

  return (
    <div className='block-container'>
      <div className='block-header'>
        {renderBreadcrumbs()}
        {/* <div className='zoom-actions'>
          <button
            className='zoom-btn'
            onClick={handleZoomOut}
            disabled={scale <= 0.2}
          >
            −
          </button>
          <span className='zoom-level'>{Math.round(scale * 100)}%</span>
          <button
            className='zoom-btn'
            onClick={handleZoomIn}
            disabled={scale >= 2.0}
          >
            +
          </button>
        </div> */}
      </div>

      <div className='block-content-wrapper overflow-x-auto w-full max-w-6xl mx-auto'>
        <div
          ref={dragRef}
          className='block-content  cursor-grab active:cursor-grabbing select-none'
          // style={{
          //   transform: state.scale < 1 ? `scale(${state.scale})` : 'none',
          //   transformOrigin: 'top left',
          //   transition: 'transform 0.2s ease',
          //   width: state.scale >= 1 ? `${state.scale * 100}%` : '100%',
          //   maxWidth: state.scale >= 1 ? 'none' : '100%'
          // }}
        >
          {/* Vista General */}
          {state.currentView === VIEWS.overview && (() => {
            const tunnels = blockConfig.flatMap((fbConfig, configIndex) => {
              const tunnelOffset = blockConfig
                .slice(0, configIndex)
                .reduce((sum, config) => sum + config.numberOfTunnels, 0)
              return Array.from({ length: fbConfig.numberOfTunnels }, (_, i) => ({
                tunnelIndex: tunnelOffset + i,
                fbConfig,
                isAccessTunnel: accessTunnel === tunnelOffset + i + 1
              }))
            })

            const maxWindows = Math.max(...blockConfig.map(c => c.numberOfWindows), 0)
            const accessIdx = accessWindow - 1

            const getLabel = (j) => {
              if (j < accessIdx) return `W${accessIdx - j}`
              if (j === accessIdx) return 'A'
              return `W${j - accessIdx}`
            }

            return (
              <div className='overview-section'>
                <div className='overview-table'>
                  {/* Header: tunnel numbers */}
                  <div className='overview-header-row'>
                    <div className='overview-row-corner' />
                    {tunnels.map(({ tunnelIndex, isAccessTunnel }) => (
                      <div
                        key={`th-${tunnelIndex}`}
                        className={`overview-col-header${isAccessTunnel ? '-access' : ''}`}
                      >
                        {tunnelIndex + 1}
                      </div>
                    ))}
                  </div>

                  {/* Window rows */}
                  {Array.from({ length: maxWindows }, (_, j) => {
                    const isAccessRow = j === accessIdx
                    return (
                      <div key={`row-${j}`} className='overview-window-row'>
                        <div className={`overview-row-label${isAccessRow ? '-access' : ''}`}>
                          {getLabel(j)}
                        </div>
                        {tunnels.map(({ tunnelIndex, fbConfig, isAccessTunnel }) => {
                          const hasWindow = j < fbConfig.numberOfWindows
                          const isAccess = hasWindow && (isAccessTunnel || isAccessRow)
                          return (
                            <div
                              key={`cell-${tunnelIndex}-${j}`}
                              className={
                                !hasWindow
                                  ? 'overview-cell-empty'
                                  : isAccess
                                    ? 'overview-cell-access'
                                    : 'overview-cell'
                              }
                              onClick={() => {
                                if (!hasWindow || isAccessTunnel) return
                                handleTunnelClick(
                                  tunnelIndex,
                                  fbConfig.numberOfWindows,
                                  fbConfig.numberOfRows,
                                  fbConfig.plantsPerRow,
                                  isAccessTunnel
                                )
                              }}
                            />
                          )
                        })}
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })()}

          {/* Vista Detallada de Túnel */}
          {state.currentView === VIEWS.tunnel && state.selectedTunnel !== null && (
            <div className='tunnel-detail-view'>
              <TunnelComponent
                farmingBlockId={state.selectedFarmingBlockId}
                tunnelNumber={state.selectedTunnel + 1}
                numberOfWindows={state.numberOfWindows}
                accessWindow={accessWindow}
                isHydroponicBlock={isHydroponicBlock}
                toggleIsTunnelRowModalOpen={toggleIsTunnelRowModalOpen}
                onExposeRefresh={(refreshFn) => {
                  tunnelRefreshRef.current = refreshFn
                }}
                // rowStates={rowStates}
                // onRowStatus={handleRowStatus}
                // accessTunnel={accessTunnel}
                // onRowClick={handleRowClick}
              />
            </div>
          )}

          {/* Vista de Plantas en Fila */}
          {/* {currentView === VIEWS.row && selectedRow !== null && (
            <div className='plants-view'>
              <div className='section-header'>
                <div className='section-title'>
                  <h4>Row {selectedRow + 1}</h4>
                  <span className='tunnel-reference'>Tunnel {selectedTunnel + 1}</span>
                </div>
                <div className='row-stats'>
                  <div className='stat-badge'>
                    <span className='stat-value'>{plantsPerRow}</span>
                    <span className='stat-label'>Plants</span>
                  </div>
                </div>
              </div>

              <div className='status-markers'>
                <div
                  className='status-marker healthy'
                  draggable
                  onDragStart={(e) => handleDragStart(e, PLANT_STATES.HEALTHY)}
                >
                  Healthy
                </div>
                <div
                  className='status-marker disease'
                  draggable
                  onDragStart={(e) => handleDragStart(e, PLANT_STATES.DISEASE)}
                >
                  Disease
                </div>
                <div
                  className='status-marker nutrient-deficiency'
                  draggable
                  onDragStart={(e) => handleDragStart(e, PLANT_STATES.NUTRIENT_DEFICIENCY)}
                >
                  Nutrient Deficiency
                </div>
              </div>

              <div className='plants-container'>
                <div className='plants-grid'>
                  {plants.map((plant, index) => (
                    <div
                      key={plant.id}
                      onDragOver={handleDragOver}
                      onDrop={(e) => handleDrop(e, index)}
                      className='plant-wrapper'
                    >
                      <PlantComponent
                        plantNumber={plant.number}
                        status={plant.status}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )} */}
        </div>
      </div>
    </div>
  )
}

BlockMapComponent.propTypes = {
  blockConfig: PropTypes.arrayOf(
    PropTypes.shape({
      numberOfTunnels: PropTypes.number.isRequired,
      numberOfWindows: PropTypes.number.isRequired,
      numberOfRows: PropTypes.number,
      plantsPerWindow: PropTypes.number
    })
  ).isRequired,
  farmingBlockId: PropTypes.number.isRequired,
  toggleIsTunnelRowModalOpen: PropTypes.func.isRequired,
  accessWindow: PropTypes.number.isRequired,
  accessTunnel: PropTypes.number.isRequired,
  isHydroponicBlock: PropTypes.bool
}

export default BlockMapComponent
